module.exports = __webpack_public_path__ + "img/13.6423bdc5.png";